/**
 * @generated SignedSource<<a0682043e40cee950c9c28ff2b868efd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GivePointsToPanelistInput = {
  clientMutationId?: string | null;
  expectedCostUsdCents: number;
  panelistId: string;
  points: number;
};
export type GivePointsToPanelistModal_givePointsToPanelist_Mutation$variables = {
  input: GivePointsToPanelistInput;
};
export type GivePointsToPanelistModal_givePointsToPanelist_Mutation$data = {
  readonly givePointsToPanelist: {
    readonly panelist: {
      readonly rewardsBalance: number | null;
    } | null;
  } | null;
};
export type GivePointsToPanelistModal_givePointsToPanelist_Mutation = {
  response: GivePointsToPanelistModal_givePointsToPanelist_Mutation$data;
  variables: GivePointsToPanelistModal_givePointsToPanelist_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsBalance",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GivePointsToPanelistModal_givePointsToPanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GivePointsToPanelistPayload",
        "kind": "LinkedField",
        "name": "givePointsToPanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GivePointsToPanelistModal_givePointsToPanelist_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GivePointsToPanelistPayload",
        "kind": "LinkedField",
        "name": "givePointsToPanelist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PanelistNode",
            "kind": "LinkedField",
            "name": "panelist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7546989c5ce4d1dc29c82918dc5df16",
    "id": null,
    "metadata": {},
    "name": "GivePointsToPanelistModal_givePointsToPanelist_Mutation",
    "operationKind": "mutation",
    "text": "mutation GivePointsToPanelistModal_givePointsToPanelist_Mutation(\n  $input: GivePointsToPanelistInput!\n) {\n  givePointsToPanelist(input: $input) {\n    panelist {\n      rewardsBalance\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c16293b46977312886a1330c4c31d36f";

export default node;
